import {
  TestTakerSettings,
  TestTakerSettingsContext,
} from "@natklok/contexts/testTakerSettingsContext";
import { useContext } from "react";

export const useSettings = (): TestTakerSettings => {
  const [settings] = useContext(TestTakerSettingsContext);
  return settings;
};
